<template>
  <tr @click="processClick" :class="{ 'cursor-pointer': action }">
    <td class="item-category">
      <div class="d-flex align-items-center font-weight-bold">
        <i class="far fa-fw p-1 mr-2" :class="item.boardItemCategory.icon"></i>
        {{ item.boardItemCategory.name }}
      </div>
      <div>
        <i class="far fa-fw mr-2"></i>
        {{ item.boardItemType.name }}
      </div>
    </td>
    <td>
      <div class="badge badge-pill badge-info sh-prop-s" v-if="displayRelevantBadge">Relevant</div>
      <div class="font-weight-bold">{{ item.title }}</div>

      <div v-simplify-html="item.description" />
    </td>
    <td class="item-labels">
      <div class="mt-2 container">
        <div class="row">
          <div v-for="label in item.labels" :key="label.id" @click.prevent.stop="selectLabel(label)">
            <div class="mr-2 mb-2 item-label" :style="{ 'background-color': label.color }">
              <i v-if="label.icon" :class="label.icon" class="mr-1 ml-1"></i>
              {{ label.title }}
            </div>
          </div>
        </div>
      </div>
    </td>
    <td class="item-icons">
      <div class="mt-2 text-secondary" v-if="item.attachments.length > 0">
        <i class="far fa-file"></i>
        {{ item.attachments.length }}
      </div>
    </td>
    <td class="item-icons">
      <div class="mt-2 text-secondary" v-if="item.comments.filter((x) => !x.isSystemComment).length > 0">
        <i class="far fa-comment"></i>
        {{ item.comments.filter((x) => !x.isSystemComment).length }}
      </div>
    </td>

    <td class="item-icons">
      <div class="mt-2 text-secondary" v-if="displayChecklistProgress">
        <i class="fas fa-tasks"></i>
        {{ closedChecklistsCount }}
      </div>
    </td>

    <td class="font-weight-bold item-date">
      <div>Created: {{ item.createdDate | formatDateTime }}</div>
      <div v-if="item.archivedDate">Archived: {{ item.archivedDate | formatDateTime }}</div>
      <div v-else>Archived: -</div>
      <div></div>
    </td>
    <td class="align-middle item-status">
      <BoardItemStatus
        :status="getBoardItemStatus(item)"
        :styles="{
          'font-size': '0.9em',
          width: '100px',
        }"
      />
    </td>
  </tr>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';
  import { BoardItemDto, BoardItemStatusDto, LabelDto } from '@/apiclient/apiclient_generated';
  import BoardItemStatus from '../BoardItem/BoardItemStatus.vue';

  @Component({
    components: {
      BoardItemStatus,
    },
  })
  export default class BoardItemOverview extends Vue {
    @Prop() item: BoardItemDto;
    @Prop() action: any;
    @Prop() actionParam: any;
    @Prop() displayRelevantBadge: boolean;

    get displayChecklistProgress() {
      return this.item.checklists.length && this.item.checklists.some((_) => _.items.length);
    }

    get closedChecklistsCount() {
      const tasks = this.item.checklists.map((_) => _.items.length).reduce((a, b) => a + b, 0);
      const completedTasks = this.item.checklists.map((_) => _.items.filter((_) => _.isCompleted).length).reduce((a, b) => a + b);

      return `${completedTasks} of ${tasks}`;
    }

    selectLabel(label: LabelDto) {
      this.$root.$emit('boardItemOverview::labelSelected', label);
    }

    processClick() {
      if (this.action) {
        this.action(this.actionParam);
      }
    }

    getBoardItemStatus(item) {
      return item.isShared ? BoardItemStatusDto.Shared : item.handoversStatus || item.boardItemStatus;
    }
  }
</script>

<style scoped lang="scss">
  .item-category {
    width: 300px;
  }

  .item-status {
    width: 175px;
  }

  .item-icons {
    width: 100px;
    max-width: 100px;
    padding-left: 10px;
  }

  .item-date {
    width: 250px;
  }

  .item-labels {
    max-width: 400px;
    width: 350px;

    .item-label {
      color: white;
      padding: 2px 5px;
      border-radius: 3px;
      font-size: 0.9rem;
    }
  }

  .item-text {
    flex-basis: 500px;
    padding-right: 30px;
    div {
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
</style>
